import React from 'react';
import { p } from '../../i18n/useP';
import './PoolAdvice.css';

/* Conseil de découpage en groupes ressources — demandé par Olivier le
   2026-08-21 : « le dirigeant se cherche souvent sur le meilleur regroupement ».

   Le découpage est LE choix qui décide de la qualité du coût horaire, et rien à
   l'écran n'aidait à le faire : on arrivait sur une liste vide avec un bouton
   « + Définir les groupes ». Trois tests, tirés de la littérature TD-ABC
   (Kaplan & Anderson, « Time-Driven Activity-Based Costing », HBR nov. 2004 et
   HBS working paper 04-045), qui se vérifient sans calcul :

     1. l'homogénéité (un seul taux crédible pour tout le groupe),
     2. le rattachement (un groupe qu'on peut nommer devant un client),
     3. la taille (ni groupe d'une personne, ni fourre-tout).

   Le repère 80–85 % vient du même corpus : la capacité pratique s'y situe
   généralement, une fois retirés congés, formation et temps non productif.
   S'en écarter n'est pas une faute — mais mérite une explication. */

const TESTS = [
  {
    t: () => p('Un seul taux crédible ?'),
    d: () => p("Un groupe est homogène si un coût horaire unique a du sens pour tous ses membres. Si deux métiers du même groupe coûtent du simple au double, ce sont deux groupes."),
  },
  {
    t: () => p('Rattachable à un service ?'),
    d: () => p("Partir des départements ou des prestations vendues, et ne scinder que lorsque les taux divergent vraiment. Un groupe qu'on ne sait pas nommer devant un client ne sert à rien."),
  },
  {
    t: () => p('Ni solo, ni fourre-tout'),
    d: () => p("Un groupe d'une seule personne devient nominatif et fragile ; un groupe attrape-tout produit une moyenne qui ne pilote rien. Et garder les mêmes groupes d'une année à l'autre, sinon les taux ne se comparent plus."),
  },
];

export default function PoolAdvice() {
  return (
    <div className="pool-advice">
      <p className="pool-advice__title">{p('Trois tests avant de découper')}</p>
      <div className="pool-advice__grid">
        {TESTS.map((x, i) => (
          <div className="pool-advice__card" key={i}>
            <b>{x.t()}</b>
            <span>{x.d()}</span>
          </div>
        ))}
      </div>
      <p className="pool-advice__src">
        {p('Repère : la capacité pratique se situe généralement entre 80 et 85 % du temps théorique (Kaplan & Anderson, Time-Driven Activity-Based Costing). En dessous, vérifier ce qui a été déchargé.')}
      </p>
    </div>
  );
}
